import React, { memo } from "react";
import PropTypes from "prop-types";
import Image from "../Image";

const DashedLineImages = ({ desktopSrc, mobileSrc }) => (
  <div>
    <Image
      src={desktopSrc}
      alt="line"
      className="md:block hidden"
      width="801"
      height="1"
      style={{ width: "auto", height: "auto" }}
    />
    <Image
      src={mobileSrc}
      alt="line"
      className="md:hidden block mt-[50px]"
      width="687"
      height="2"
      style={{ width: "auto", height: "auto" }}
    />
  </div>
);

DashedLineImages.propTypes = {
  desktopSrc: PropTypes.string.isRequired,
  mobileSrc: PropTypes.string.isRequired,
};

export default memo(DashedLineImages);
